import * as React from 'react';
import { ContactsSidebar } from './ContactsSidebar';
import { ContactsList } from './ContactsList';
import type { ContactsOrgNode } from '../types';

export function ContactsLayout() {
  const [selectedOrg, setSelectedOrg] = React.useState<ContactsOrgNode | undefined>();

  return (
    <div className="flex h-full w-full border-t border-divider">
      <ContactsSidebar onSelectChange={setSelectedOrg} selectedOrg={selectedOrg} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <ContactsList selectedOrg={selectedOrg} />
      </div>
    </div>
  );
}
